import { useCallback, useEffect } from 'react';
import { mixpanelTrack } from '@/providers/Mixpanel';
import { getAvailableSpaceInMB, rxdbError } from '../rxdb.tools';
import { MINIMUM_AVAILABLE_MEMORY_IN_MB } from '../rxdb.constants';

/**
 * Checks the available memory on the current domain.
 * If there's less than 1GB available, it should print an error to the console.
 * @returns {void}
 */
function useCheckAvailableMemory(): void {
  const checkAvailableMemory = useCallback(async () => {
    try {
      const availableMemory = await getAvailableSpaceInMB();

      if (availableMemory >= 0 && availableMemory < MINIMUM_AVAILABLE_MEMORY_IN_MB) {
        // addToast(
        //   useToast.ToastTypeVariants.ERROR,
        //   'You are running low on memory. Please free up space on your hard drive to continue using Glade.ai without performance issues.',
        // );
        mixpanelTrack(`Available memory is low`, { availableMemory, limit: MINIMUM_AVAILABLE_MEMORY_IN_MB});
        rxdbError(`Available memory is low`, { availableMemory, limit: MINIMUM_AVAILABLE_MEMORY_IN_MB });
      }
    } catch (error) {
      rxdbError('Error checking available memory', { error });
    }
  }, []);

  useEffect(() => {
    checkAvailableMemory();
  }, [checkAvailableMemory]);
}

export default useCheckAvailableMemory;
